import {Copy} from "./Copy";

export const DefaultCopy: Copy = {
    start: {
        header: {
            title: "Let's verify your ID",
            subtitle: "Just quickly confirming it’s really you."
        },
        id: {
            header: "Take a picture of your valid ID",
            text: "To check your personal information, you can use either a valid passport or New Zealand driver's licence."
        },
        selfie: {
            header: "Take a selfie of yourself",
            text: "This is to match to your ID, so we know it’s you."
        }
    }

}